/* eslint-disable default-case */
import React, {useState, useEffect} from 'react'

import { Text, View, StyleSheet } from '@react-pdf/renderer';

export default function RecapDay(props) {

    const styles = StyleSheet.create({
        text: {
            fontSize: 11,
            marginTop: "5px"
        },
        title: {
            fontSize: 20,
        },
        menu: {
            fontSize: 14,
            fontWeight: "bold",
            marginBottom: "10px",
            marginTop: "10px"
        }
    })

    const [Day, setDay] = useState([]);
    const [Date, setDate] = useState('');

    // menu A
    const [MenuACounter, setMenuACounter] = useState(0);
    const [MenuBCounter, setMenuBCounter] = useState(0);

    // menu B
    const [MenuDCounter, setMenuDCounter] = useState(0);
    const [MenuHCounter, setMenuHCounter] = useState(0);
    const [MenuSVCounter, setMenuSVCounter] = useState(0);
    const [MenuSPCounter, setMenuSPCounter] = useState(0);

    // potage & diner
    const [PotageCounter, setPotageCounter] = useState(0);
    const [BrickCounter, setBrickCounter] = useState(0);
    const [DinerCounter, setDinerCounter] = useState(0);

    useEffect(() => {
        const getContent = () => {
            props.firebase.getMenusDate(props.uid, props.week, props.Day).get()
            .then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    props.firebase.getMenusContent(props.uid, props.week, props.Day, doc.id).get()
                    .then( doc => {
                        const mydata = doc.data()
                        setDay(mydata)
                        setDate(doc.id)
                    })
                })
            })
        }
        getContent()
    }, [props.Day, props.firebase, props.uid, props.week]);

    useEffect(() => {
        if (props.firebase) {
            const getListing = () => {
                let menuACount = 0;
                let menuBCount = 0;
                let menuDCount = 0;
                let menuHCount = 0;
                let menuSVCount = 0;
                let menuSPCount = 0;
                let potageCount = 0;
                let brickCount = 0;
                let dinerCount = 0;

                props.firebase.getCustomers(props.uid).get()
                .then(querySnapshot => {
                    querySnapshot.docs.forEach(doc => {
                        if (doc.data().tourNum === props.tour) {
                            props.firebase.getMenuNbr(props.uid, props.week, doc.id, props.Day).get()
                            .then( doc => {
                                doc.docs.forEach(result => {
                                    switch (result.data().menu) {
                                        case 'MenuA':
                                            menuACount += 1;
                                            if (result.data().potage) {
                                                potageCount += Number(result.data().potagenbr) || 1;
                                            }
                                            if (result.data().brick) {
                                                brickCount += Number(result.data().bricknbr) || 1;
                                            }
                                            if (result.data().diner) {dinerCount += 1}
                                            break;
                                        case 'MenuB':
                                            menuBCount += 1;
                                            if (result.data().potage) {
                                                potageCount += Number(result.data().potagenbr) || 1;
                                            }
                                            if (result.data().brick) {
                                                brickCount += Number(result.data().bricknbr) || 1;
                                            }
                                            if (result.data().diner) {dinerCount += 1}
                                            break;
                                        case 'MenuD':
                                            menuDCount += 1;
                                            if (result.data().potage) {
                                                potageCount += Number(result.data().potagenbr) || 1;
                                            }
                                            if (result.data().brick) {
                                                brickCount += Number(result.data().bricknbr) || 1;
                                            }
                                            if (result.data().diner) {dinerCount += 1}
                                            break;
                                        case 'MenuH':
                                            menuHCount += 1;
                                            if (result.data().potage) {
                                                potageCount += Number(result.data().potagenbr) || 1;
                                            }
                                            if (result.data().brick) {
                                                brickCount += Number(result.data().bricknbr) || 1;
                                            }
                                            if (result.data().diner) {dinerCount += 1}
                                            break;
                                        case 'MenuSV':
                                            menuSVCount += 1;
                                            if (result.data().potage) {
                                                potageCount += Number(result.data().potagenbr) || 1;
                                            }
                                            if (result.data().brick) {
                                                brickCount += Number(result.data().bricknbr) || 1;
                                            }
                                            if (result.data().diner) {dinerCount += 1}
                                            break;
                                        case 'MenuSP':
                                            menuSPCount += 1;
                                            if (result.data().potage) {
                                                potageCount += Number(result.data().potagenbr) || 1;
                                            }
                                            if (result.data().brick) {
                                                brickCount += Number(result.data().bricknbr) || 1;
                                            }
                                            if (result.data().diner) {dinerCount += 1}
                                            break;
                                    }
                                    setMenuACounter(menuACount);
                                    setMenuBCounter(menuBCount);
                                    setMenuDCounter(menuDCount);
                                    setMenuHCounter(menuHCount);
                                    setMenuSVCounter(menuSVCount);
                                    setMenuSPCounter(menuSPCount);
                                    setPotageCounter(potageCount);
                                    setBrickCounter(brickCount);
                                    setDinerCounter(dinerCount);
            
                                })
                            })
                        }
                    }) 
                })
            }
            getListing()
        }
    }, [Day, props.Day, props.firebase, props.tour, props.uid, props.week]);

    return (
                <View style={{display: "flex", flexDirection: "column", alignItems: "center", marginTop: "20px"}}>
                    <Text>tournée {props.tour}</Text>
                    <div style={{display: "flex", flexDirection: "row"}}>
                        <Text style={{marginRight: "10px"}}>{props.jour}</Text>
                        <Text>{Date}</Text>
                    </div>
                    <Text style={styles.menu}>Nombre de Menu A : {MenuACounter}</Text>
                    <Text style={styles.menu}>Nombre de Menu B : {MenuBCounter}</Text>
                    <Text style={styles.menu}>Nombre de Menu diabétique : {MenuDCounter}</Text>
                    <Text style={styles.menu}>Nombre de Menu haché : {MenuHCounter}</Text>
                    <Text style={styles.menu}>Nombre de Menu sans viande : {MenuSVCounter}</Text>
                    <Text style={styles.menu}>Nombre de Menu sans poisson : {MenuSPCounter}</Text>
                    <Text style={{textDecoration: "underline", fontSize: 15, marginTop: "7px"}}>Potages :</Text>
                    <Text style={styles.text}>{Day.potage} : <Text style={{fontWeight: "bold"}}>{PotageCounter}</Text></Text>
                    <Text style={{textDecoration: "underline", fontSize: 15, marginTop: "7px"}}>Briques :</Text>
                    <Text style={styles.text}>{Day.brick} : <Text style={{fontWeight: "bold"}}>{BrickCounter}</Text></Text>
                    <Text style={{textDecoration: "underline", fontSize: 15, marginTop: "7px"}}>Diners léger :</Text>
                    <Text style={styles.text}>{Day.diner} : <Text style={{fontWeight: "bold"}}>{DinerCounter}</Text></Text>
                </View>
    )
}